// extracted by mini-css-extract-plugin
export default {"link":"C1NVg8","root":"m14IQl","label":"h6imkB"};